import React from "react";
import PageBase from "../components/PageBase";
import { Helmet } from "react-helmet";

const Boxeak = () => {
  const styles = {
    images: {
      width: "800px",
      maxWidth: "100%",
    },
  };

  return (
    <PageBase title="Boxeak" navigation="Oñatiko Duatloi Txikia / Boxeak">
      <Helmet>
        <title>Oñatiko Dutloi Txikia Boxeak</title>
        <meta
          name="description"
          content="Oñatiko duatloi txikiko boxeen antolamendua"
        />
        <meta property="og:title" content="Oñatiko Dutloi Txikia Boxeak" />
        <meta
          property="og:description"
          content="Oñatiko duatloi txikiko boxeen antolamendua"
        />
        <meta
          property="og:url"
          content="http://duatloitxikia.oinatikoduatloia.com/boxeak"
        />
        <meta
          property="og:image"
          content="http://duatloitxikia.oinatikoduatloia.com/boxeak.png"
        />
      </Helmet>

      <div className="row">
        <div className="col-md-12">
          <center>
            <img src={require("../images/boxeak.png")} style={styles.images} />
          </center>
        </div>
      </div>
    </PageBase>
  );
};

export default Boxeak;



/** WEBPACK FOOTER **
 ** ./src/containers/Boxeak.js
 **/